import React from 'react';

import { Box, Center, HStack } from '@chakra-ui/react';

import { getIcon } from 'components/DataDisplay';
import { IntegrationsTabs } from 'containers/Setup/Integrations/types';

export const getResourceIcon = type => (
  <Center w="full" h="full" color="primary">
    {getIcon(type)}
  </Center>
);

export const getLabel = type => {
  switch (type) {
    case IntegrationsTabs.Jira:
      return 'Atlassian JIRA';
    case IntegrationsTabs.Sms:
      return 'SMS';
    case IntegrationsTabs.Slack:
      return 'Slack';
    case IntegrationsTabs.Teams:
      return 'Microsoft Teams';
    case IntegrationsTabs.Email:
      return 'Email Group';
    case IntegrationsTabs.Servicenow:
      return 'Servicenow';
    case IntegrationsTabs.Sso:
      return 'Single Sign-On';
    case IntegrationsTabs.AzureAd:
      return 'Azure Active Directory';
    case IntegrationsTabs.Okta:
      return 'Okta';
    case IntegrationsTabs.Saas:
      return 'SaaS';
    case IntegrationsTabs.Snowflake:
      return 'Snowflake';
    case IntegrationsTabs.IdentityAndAccess:
      return 'Identity & Access';
    case IntegrationsTabs.Siem:
      return 'SIEM';
    case IntegrationsTabs.Elasticsearch:
      return 'Elastic for SIEM';
    case IntegrationsTabs.Gitlab:
      return 'GitLab';
    case IntegrationsTabs.Github:
      return 'Github';
    case IntegrationsTabs.Bitbucket:
      return 'Atlassian BitBucket';
  }
  return type;
};

export const renderNavTitle = type => (
  <HStack justify="space-between" w="full" h="full">
    <Box>{getLabel(type)}</Box>
    <Center boxSize={5}>{getResourceIcon(type)}</Center>
  </HStack>
);
